// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"style_tooltipWrapper__uxL0D"};